import { render } from "./verification-code.vue?vue&type=template&id=5300561c"
import script from "./verification-code.vue?vue&type=script&lang=js"
export * from "./verification-code.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__